import raw from 'raw.macro';

export default [
  { title: 'State Updates', content: raw('./state-updates.md') },
  { title: 'Adding Elements', content: raw('./adding-elements.md') },
  { title: 'Removing Elements', content: raw('./removing-elements.md') },
  { title: 'Changing Elements', content: raw('./changing-elements.md') },
  { title: 'Changing Properties', content: raw('./changing-properties.md') },
  { title: 'Removing Properties', content: raw('./removing-properties.md') },
];
